const DEPARTMENTS = [
  { value: 'logistics',          label: 'Logistics' },
  { value: 'technology',         label: 'Technology' },
  { value: 'investment',         label: 'Investment' },
  { value: 'project_manager',    label: 'Project Manager' },
  { value: 'transit_official',   label: 'Transit Official' },
  { value: 'transport_official', label: 'Transport Official' },
  { value: 'sales',              label: 'Sales' },
  { value: 'admin',              label: 'Administration' },
]

const PROJECT_RUBRICS = ['Infrastructure', 'Logistics', 'Technology', 'Trade', 'Investment', 'Training', 'Other']
const PROJECT_STATUSES = ['planning', 'active', 'on-hold', 'completed']

const EMPTY_WORKER   = { name: '', role: '', department: 'logistics', region: '', email: '', phone: '', password: '' }
const EMPTY_TRAINING = { title: '', description: '', duration: '', category: 'logistics' }

const EMPTY_EQUIP    = { title: '', price: '', details: '', images: [] }
const EMPTY_PROJECT  = { title: '', rubric: 'Infrastructure', description: '', assignedTo: '', startDate: '', dueDate: '', status: 'planning' }
const EMPTY_SALE     = { client: '', product: '', amount: '', status: 'quote', date: '', notes: '', invoiceUrl: '' }

/** Shared sale / quote / invoice statuses */
const SALE_STATUSES = [
  { value: 'quote',     label: { en: 'Quote', fr: 'Devis' } },
  { value: 'accepted',  label: { en: 'Accepted', fr: 'Accepté' } },
  { value: 'invoice',   label: { en: 'Invoice', fr: 'Facture' } },
  { value: 'confirmed', label: { en: 'Confirmed', fr: 'Confirmée' } },
  { value: 'delivered', label: { en: 'Delivered', fr: 'Livrée' } },
  { value: 'paid',      label: { en: 'Paid', fr: 'Payée' } },
  { value: 'cancelled', label: { en: 'Cancelled', fr: 'Annulée' } },
]

const QUOTE_STATUSES = ['quote', 'accepted', 'pending']
const INVOICE_STATUSES = ['invoice', 'confirmed', 'delivered', 'paid']

export {
  DEPARTMENTS, PROJECT_RUBRICS, PROJECT_STATUSES,
  EMPTY_WORKER, EMPTY_TRAINING, EMPTY_EQUIP, EMPTY_PROJECT, EMPTY_SALE,
  SALE_STATUSES, QUOTE_STATUSES, INVOICE_STATUSES,
}
